export default "__VITE_ASSET__Drl2Ds7A__"